export enum GbrPersonType {
  Spouse = 'Spouse',
  Child = 'Child',
  Other = 'Other'
}
